var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.87166C7.00013 6.98461 6.9779 7.09647 6.93458 7.20082C6.89126 7.30516 6.82771 7.39992 6.74758 7.47966L1.45877 12.7597C1.29621 12.9158 1.07877 13.0021 0.853176 13C0.627581 12.9978 0.411834 12.9074 0.252306 12.7481C0.0927789 12.5889 0.00220298 12.3735 3.96205e-05 12.1482C-0.00212374 11.923 0.0842973 11.7059 0.240736 11.5437L4.92054 6.87166L0.240736 2.19966C0.0842969 2.03738 -0.00212418 1.8203 3.91592e-05 1.59508C0.0022025 1.36986 0.0927784 1.15447 0.252306 0.995212C0.411833 0.83595 0.62758 0.745523 0.853176 0.743363C1.07877 0.741203 1.29621 0.827483 1.45877 0.983662L6.74758 6.26366C6.82771 6.3434 6.89126 6.43816 6.93458 6.54251C6.9779 6.64685 7.00013 6.75871 7 6.87166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.08f7f5bd9eb890b4506b9969e876940b.svg";
export { ForwardRef as ReactComponent };